//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        state: {
            type: [Number, String],
            default: 0
        },
        rowguid: {
            type: String,
            default: ''
        }
    },
    data () {
        return {

        }
    },
    computed: {
        elstate() {
            var obj = {
                '0': '',
                '1': 'success',
                '2': 'danger',
                '9': 'info'
            };
            return obj[this.state + ''];
        },
        eltext() {
            var obj = {
                '0': '审核中',
                '1': '审核通过',
                '2': '审核退回',
                '9': '未上报'
            };
            return obj[this.state + ''];
        }
    },
    methods: {
        gotoTree(e) {
            if(!this.rowguid) return;

            this.goto('/wx/audit/listtree/'+this.rowguid)
        }
    },
    mounted: function() {

    }
}
